import * as React from 'react';
import './styles.scss';

import { RangeSliderProps, NumberRange, RangeSlider } from '@blueprintjs/core';
import { parseInt } from 'lodash';
import { useState } from 'react';

export interface IControlRangeProps {
    min: number;
    max: number;
    stepSize: number;
    value: NumberRange;
    onRelease: (value: NumberRange) => void;
    onChange: (value: NumberRange) => void;
    labelMin?: string;
    labelMax?: string;
}

const ControlRange: React.FunctionComponent<IControlRangeProps> = (props) => {
    const [range, setRange] = useState<[number, number]>([props.value[0] || props.min, props.value[1] || props.max]);

    const updateFilter = (el: EventTarget & HTMLInputElement, isMin: boolean) => {
        let newRange = range;

        if (parseInt(el.value) < parseInt(el.min)) {
            if (isMin) {
                newRange = [parseInt(el.min), range[1]];
            } else {
                newRange = [range[0], parseInt(el.min)];
            }
        } else if (parseInt(el.value) > parseInt(el.max)) {
            if (isMin) {
                newRange = [parseInt(el.max), range[1]];
            } else {
                newRange = [range[0], parseInt(el.max)];
            }
        }
        setRange(newRange);

        if (newRange[0] <= newRange[1]) {
            props.onRelease(newRange);
        }
    };

    const sliderChange = (range: NumberRange) => {
        props.onChange(range);
        setRange(range);
    };


    return (
        <div className="range-slider">
            <div className="range-slider-fields">
                <label>
                    {props.labelMin ? props.labelMin : 'Min'}
                    <input
                        type="number"
                        min={props.min}
                        max={props.max}
                        value={range[0]}
                        onChange={(e) => {
                            if (!isNaN(parseInt(e.target.value))) {
                                setRange([parseInt(e.target.value), range[1]]);
                            } else {
                                setRange([0, range[1]]);
                            }
                        }}
                        onBlur={(e) => {
                            updateFilter(e.target, true);
                        }}
                    />
                </label>
                <label>
                    {props.labelMax ? props.labelMax : 'Max'}
                    <input
                        type="number"
                        min={props.min}
                        max={props.max}
                        value={range[1]}
                        onChange={(e) => {
                            if (!isNaN(parseInt(e.target.value))) {
                                setRange([range[0], parseInt(e.target.value)]);
                            }else {
                                setRange([range[0], 0]);
                            }
                        }}
                        onBlur={(e) => {
                            updateFilter(e.target, false);
                        }}
                    />
                </label>
            </div>
            {props.value && props.value[0] >= 0 && props.value[1] >= 0 && (
                <RangeSlider
                    showTrackFill={true}
                    min={props.min}
                    max={props.max}
                    value={props.value}
                    stepSize={props.stepSize}
                    labelStepSize={props.max}
                    labelPrecision={0}
                    onChange={sliderChange}
                    onRelease={props.onRelease}
                />
            )}
        </div>
    );
};

ControlRange.displayName = 'ControlRange';

export default ControlRange;
